import get from 'lodash.get';

const findBranch = (branch, metaData, decisionState) => {
    if (typeof branch.props.when === 'function') {
        return branch.props.when?.(decisionState);
    } else {
        // Use lodash.get here after injecting the current context index into field path!
        const metadataKeys = Object.keys(metaData);
        const fieldName = Array.isArray(branch.props.when.field)
            ? branch.props.when.field
                  .map(segment => {
                      if (metadataKeys.includes(segment)) {
                          return `${segment}[${metaData[segment]}]`;
                      }
                      return segment;
                  })
                  .join('.')
            : branch.props.when.field;
        const value = get(decisionState, fieldName);

        if (typeof branch.props.when.comparitor === 'function') {
            return branch.props.when.comparitor(value);
        } else {
            switch (branch.props.when.comparitor) {
                case '>':
                    return value > branch.props.when.value;
                case '>=':
                    return value >= branch.props.when.value;
                case '<':
                    return value < branch.props.when.value;
                case '<=':
                    return value <= branch.props.when.value;
                case '!=':
                    // eslint-disable-next-line eqeqeq
                    return value != branch.props.when.value;
                case '!==':
                    return value !== branch.props.when.value;
                case '===':
                    return value === branch.props.when.value;
                // ==
                default:
                    // eslint-disable-next-line eqeqeq
                    return value == branch.props.when.value;
            }
        }
    }
};

export {findBranch};
